import { render, staticRenderFns } from "./teaser.vue?vue&type=template&id=d4790fba&"
import script from "./teaser.vue?vue&type=script&lang=js&"
export * from "./teaser.vue?vue&type=script&lang=js&"
import style0 from "./teaser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports